import React, { useState } from 'react';
import './index.css';

function AdminTile (props) {
    const {
        name,
        sub,
        handleDelete,
        type,
        hiddenItems
    } = props;
    
    const [isViewing, setIsViewing] = useState(false);

    const toggleView = () => {
        setIsViewing(!isViewing);
    }

    return (
        <div className="adminTile">
            <div className="topHalf">
                <div className="leftHalf">
                    <h1>{name}</h1>
                    <h3>{sub}</h3>
                </div>
                <div className="rightHalf">
                    <button className="pink" onClick={handleDelete} style={{marginBottom: "10px"}}>Delete</button>
                    <button className="pink" onClick={toggleView}>See {type}</button>
                </div>
            </div>
            {isViewing &&
                <ul>
                    {hiddenItems.length === 0 && <li key={"none"}>None</li>}
                    {hiddenItems.map((item, index) => {
                        return <li key={index + item}>{item}</li>
                    })}
                </ul>
            }
        </div>
    );
}

export default AdminTile;
